<div class="ma-container" [formGroup]="formGroup">
  <div class="ma-card">
    <div class="row g-3">
      <div class="col-md-6">
        <label class="field-label">Letter of Undertaking for Register of Interests in Securities</label>
        <div class="upload-box" (click)="!readonly() && louFile.click()">
          <input #louFile type="file" hidden [disabled]="readonly()"
            (change)="onFileSelected($event, 'letterOfUndertaking', 'letterOfUndertakingFile')">
          @if (!fileName('letterOfUndertaking')) {
          <!-- <mat-icon>upload_file</mat-icon> -->
          <span class="file-drop-text">Choose a file</span>
          } @else {
          <!-- <mat-icon class="file-type-icon">insert_drive_file</mat-icon> -->
          <span class="file-drop-text">{{ fileName('letterOfUndertaking') }}</span>
          @if (!readonly()) {
          <button type="button" class="file-clear"
            [disabled]="readonly() || (isUploading() && uploadingControl === 'letterOfUndertaking')"
            (click)="$event.stopPropagation(); clearFile('letterOfUndertaking', louFile, 'letterOfUndertakingFile')">
            <mat-icon>close</mat-icon>
          </button>
          }
          }
          @if (hasAttachment('letterOfUndertaking')) {
          <button type="button" class="file-preview"
            (click)="$event.stopPropagation(); previewAttachment('letterOfUndertaking')">
            <mat-icon>visibility</mat-icon>
          </button>
          }
        </div>
        @if (formGroup.get('letterOfUndertaking')?.hasError('invalidType')) {
        <div class="validation-error">Only PDF, JPG, PNG files are allowed.</div>
        }
        @if (formGroup.get('letterOfUndertaking')?.hasError('maxSize')) {
        <div class="validation-error">File size must be less than or equal to 5MB.</div>
        }

      </div>

      <div class="col-md-6">
        <label class="field-label">Securities Interest Register</label>
        <div class="upload-box" (click)="!readonly() && sirFile.click()">
          <input #sirFile type="file" hidden [disabled]="readonly()"
            (change)="onFileSelected($event, 'securitiesInterestRegister', 'securitiesInterestRegisterFile')">
          @if (!fileName('securitiesInterestRegister')) {
          <!-- <mat-icon>upload_file</mat-icon> -->
          <span class="file-drop-text">Choose a file</span>
          } @else {
          <!-- <mat-icon class="file-type-icon">insert_drive_file</mat-icon> -->
          <span class="file-drop-text">{{ fileName('securitiesInterestRegister') }}</span>
          @if (!readonly()) {
          <button type="button" class="file-clear"
            [disabled]="readonly() || (isUploading() && uploadingControl === 'securitiesInterestRegister')"
            (click)="$event.stopPropagation(); clearFile('securitiesInterestRegister', sirFile, 'securitiesInterestRegisterFile')">
            <mat-icon>close</mat-icon>
          </button>
          }
          }
          @if (hasAttachment('securitiesInterestRegister')){
          <button type="button" class="file-preview"
            (click)="$event.stopPropagation(); previewAttachment('securitiesInterestRegister')">
            <mat-icon>visibility</mat-icon>
          </button>
          }
        </div>
        @if (formGroup.get('securitiesInterestRegister')?.hasError('invalidType')) {
        <div class="validation-error">Only PDF, JPG, PNG files are allowed.</div>
        }
        @if (formGroup.get('securitiesInterestRegister')?.hasError('maxSize')) {
        <div class="validation-error">File size must be less than or equal to 5MB.</div>
        }

      </div>
    </div>
  </div>

  <!-- One supporting-document upload per maintenance section. -->
  <div class="ma-card ma-card-spaced">
    <div class="ma-card-head">
      <div class="ma-card-head-text">
        <h6 class="ma-card-title">Section Supporting Documents</h6>
        <p class="ma-card-note">Attach a supporting document against any maintenance section.</p>
      </div>
      @if (attachedCount) {
      <span class="ma-count-chip">{{ attachedCount }} attached</span>
      }
    </div>

    <div class="row g-3">
      @for (field of supportingDocFields; track field.control) {
      <div class="col-md-6">
        <label class="field-label">
          <mat-icon class="field-label-icon">{{ field.icon }}</mat-icon>
          {{ field.label }}
        </label>

        
        <input #sectionFile type="file" hidden [disabled]="readonly()"
          (change)="onFileSelected($event, field.control, field.control + 'File'); sectionFile.value = ''">

        <div class="bank-file-list">
          @for (doc of bankDocs; track doc.id) {
          <div class="upload-box">
            <span class="file-drop-text" [title]="doc.fileName">{{ doc.fileName }}</span>
            @if (!readonly()) {
            <button type="button" class="file-clear" [disabled]="isVisible()"
              (click)="clearFile(field.control, sectionFile, field.control + 'File', doc)">
              <mat-icon>close</mat-icon>
            </button>
            }
            <button type="button" class="file-preview" (click)="previewAttachment(field.control, doc)">
              <mat-icon>visibility</mat-icon>
            </button>
          </div>
          }
        </div>

        @if (!readonly()) {
        @if (bankDocs.length) {
        <button type="button" class="file-add" [disabled]="isVisible()" (click)="sectionFile.click()">
          <mat-icon>add</mat-icon>
          <span>Add another file</span>
        </button>
        } @else {
        <div class="upload-box" (click)="!isVisible() && sectionFile.click()">
          <span class="file-drop-text">Choose a file</span>
        </div>
        }
        }
        @if (formGroup.get(field.control)?.touched) {
        @if (formGroup.get(field.control)?.hasError('invalidType')) {
        <div class="validation-error">Only PDF, JPG, PNG files are allowed.</div>
        }
        @if (formGroup.get(field.control)?.hasError('maxSize')) {
        <div class="validation-error">File size must be less than or equal to 5MB.</div>
        }
        }
      </div>
      }
    </div>
  </div>
</div>